
<div
  class="card py-10">

  <!-- client type selection -->
  <!--<div class="text-left" *ngIf="!clientTypeIsSelected">

    <button routerLink="/auth/login" ejs-button class="dl-button mr-2 h-8 mb-5">
      <svg viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
      </svg>
    </button>

    <h1 class="text-3xl text-bold pb-1">Registrati</h1>
    <h4 class="text-1xl text-bold pb-5">Seleziona il tipo di utente</h4>
    <div>
      <div class=" mt-2">
        <button ejs-button class="e-primary transform duration-300"
          (click)="getRole('cliente')">
          Cliente
        </button>
      </div>
      <div class=" mt-6">
        <button ejs-button class="e-primary transform duration-300"
          (click)="getRole('dipendente')">
          Dipendente
        </button>
      </div>
    </div>

  </div>-->
  <div class="text-left mt-16" *ngIf="isCompleted">
    <h1 class="text-3xl text-bold pb-1">Utente creato</h1>
    <h2 class="text-1xl text-bold pb-5">Torna al login</h2>
    <div class=" mt-6">
      <button ejs-button class="e-primary transform duration-300"
        (click)="route()">
        Login
      </button>
    </div>
  </div>

  <div *ngIf="showForm">
    <!-- displayed only after you pick a client type -->
    <div class="text-left">

      <!--(click)="getRole('typeSelect')"-->
      <button ejs-button [routerLink]="'/auth/login'"
        class="dl-button mr-2 h-8 mb-5">
        <svg viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
          class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
        </svg>
      </button>

      <h1 class="text-3xl text-bold pb-1">Registrati</h1>
      <h4 class="text-1xl text-bold pb-5">Inserisci le credenziali</h4>

      <div [formGroup]="formSignUp">

        <label for="username" class="text-gray-500">Username</label><br />
        <div class="relative mb-2">
          <input #username id="username" formControlName="username"
            class="e-input transform duration-300"
            (keyup)="usernameValidation(username.value)"
            (keyup.enter)="signUp()" placeholder="Inserisci l'username " />
          <ejs-message class="error-msg" severity="Error"
            [visible]="usernameExists"
            [content]="'Esiste già un utente con questo username'"></ejs-message>
        </div>

        <label for="email" class="text-gray-500">Email</label><br />
        <div class="relative mb-2">
          <input #email id="email" formControlName="email"
            class="e-input transform duration-300"
            (keyup)="mailValidation(email.value)" (keyup.enter)="signUp()"
            placeholder="Inserisci l'email " />
          <ejs-message class="error-msg" severity="Error"
            [visible]="mailNotValid"
            [content]="'La mail inserita non è valida'"></ejs-message>
          <ejs-message class="error-msg" severity="Error" [visible]="mailExists"
            [content]="'Esiste già un utente con questa email'"></ejs-message>
        </div>

        <label for="pwdInput" class="text-gray-500">Password</label><br />
        <div class="mb-3">
          <div class="relative">
            <input #pwdInput id="pwdInput" type="password"
              formControlName="password"
              (keyup)="pwdValidation(pwdInput.value)" (keyup.enter)="signUp()"
              class="e-input transform duration-300"
              placeholder="Inserisci la password " />

            <div [class]="passwIcon"
              class="absolute top-0 right-0 pwdicon flex content-center items-center align-middle"
              (click)="showPassword()"></div>
          </div>
          <h5 class="text-xs font-light text-slate-400 pwtext">La password deve
            avere almeno 8 caratteri, un
            numero e un carattere speciale</h5>
          <ejs-message class="error-msg" severity="Error"
            [visible]="pwdNotValid"
            [content]="'La password non è valida'"></ejs-message>
        </div>

        <label for="pwdInputConfirm" class="text-gray-500">Conferma la password</label><br />
        <div class="relative mb-5">
          <input #pwdInputConfirm id="pwdInputConfirm" type="password"
            formControlName="passwordConfirm"
            class="e-input transform duration-300" (keyup.enter)="signUp()"
            (keyup)="pwdCheck(pwdInputConfirm.value)"
            placeholder="Inserisci la password " />
          <ejs-message class="error-msg" severity="Error" [visible]="!pwdError"
            [content]="'Le password non combaciano'"></ejs-message>

        </div>

        <!--<div class="relative mb-3">
          <ejs-dropdownlist #roles id='ddlelement'
            class="e-input transform duration-300"
            [dataSource]='dropdownData' [fields]="{text:'role',value:'role'}"
            formControlName="ruolo"
            placeholder='Ruolo'></ejs-dropdownlist>
        </div>-->

        <div class="relative mt-6">
          <button ejs-button class="e-primary transform duration-300"
            (click)="signUp();" type="submit"
            [disabled]="formSignUp.invalid">
            Registrati
          </button>
        </div>
    <!--     <div style="font-size: 10px;color:gray; padding-top:1em; width: 25em;">
          This site is protected by reCAPTCHA and the Google
          <a href="https://policies.google.com/privacy">Privacy Policy</a> and
          <a href="https://policies.google.com/terms">Terms of Service</a>
          apply.
        </div> -->

        <ejs-message class="error-msg" severity="Error"
          [visible]="formHaveErrors" [content]="errMsg"></ejs-message>

        <ejs-message *ngIf="rispSignUp" class="error-msg" severity="Error"
          [visible]="!rispSignUp.success"
          [content]="rispSignUp.error"></ejs-message>

      <!--   <script src="https://www.google.com/recaptcha/api.js" async defer></script>
        <script>
          function onSubmit(token) {
            document.getElementById("demo-form").submit();
          }
        </script> -->

      </div>
    </div>

  </div>

</div>
